import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import "./deleteClientDialog.css"
import { CaretakersService } from '../services/supabase/caretakersService';
import { UserService } from '../services/user/userService';

export default function DeleteCaretakerDialog(props) {
  const [open, setOpen] = useState(false);
  const [statusMsg, setStatusMsg] = useState('');
  const [statusIsError, setStatusIsError] = useState(false);

  useEffect(() => {
    setOpen(props.displayDeleteCaretakerDialog);
  }, [props.displayDeleteCaretakerDialog])

  const handleClose = () => {
    props.setDisplayDeleteCaretakerDialog(false);
  };

  async function handleDeactivate() {
    let deactivDate = document.getElementById("deactivDateInput").value;
    const deactivTime = deactivDate === "" ? Date.now() : new Date(deactivDate).getTime();

    await CaretakersService.deactivate(props.caretakerToDeleteID, deactivTime);
    if (props.userToDeleteID) {
      await UserService.deleteUser(props.userToDeleteID);
    }
    await props.InitialLoadCaretakers();
    props.setCaretakerToDeleteName("");
    props.setCaretakerToDeleteID("");
    handleClose();
  }

  async function handleDelete() {
    let enteredName = document.getElementById("caretakerDeleteCheck").value.toLowerCase();
    let checkName = props.caretakerToDeleteName.toLowerCase();

    if (enteredName === checkName) {
      await CaretakersService.deleteCaretaker(props.caretakerToDeleteID);
      if (props.userToDeleteID) {
        await UserService.deleteUser(props.userToDeleteID);
      }
      await props.InitialLoadCaretakers();
      props.setCaretakerToDeleteName("");
      props.setCaretakerToDeleteID("");
      handleClose();
    } else {
      setStatusIsError(true);
      setStatusMsg("Error — entered name did not match caretaker's name. Delete aborted.");
    }
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <div className='titleAndX'>
          <DialogTitle id="form-dialog-title">Confirm Caretaker Delete</DialogTitle>
          <Button onClick={handleClose} id="cancelDeleteCaretaker">X</Button>
        </div>
        <DialogContent>
          <DialogContentText>
            <h3>Option 1 - Deactivate</h3>
            Choose <strong>'Deactivate'</strong> if you wish to preserve the financial information for {props.caretakerToDeleteName}.
          </DialogContentText>

          <div className='deactivateDiv'>
            <input type='date' id='deactivDateInput'></input> &nbsp; &nbsp;
            <div>
              <Button onClick={handleDeactivate} id="deactivateCaretaker">Deactivate</Button>
            </div>
          </div>

          <br /><br />

          <DialogContentText>
            <h3>Option 2 - Delete</h3>
            <strong>WARNING!</strong> Deleting will erase <strong>ALL</strong> previous shift and wage information for {props.caretakerToDeleteName}. <br /><br />
            To <strong>Delete</strong>, enter the caretaker's name (<strong>{props.caretakerToDeleteName}</strong>), and press <strong>'Confirm Delete'</strong>.
          </DialogContentText>
        </DialogContent>
        {statusMsg && <p style={{color: statusIsError ? 'red' : 'green', margin: '0 16px 8px'}}>{statusMsg}</p>}
        <DialogActions>
          <input id="caretakerDeleteCheck"></input>
          <Button onClick={handleDelete} id="confirmDeleteCaretaker">Confirm Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
